import { render } from "./SnehaSparshamApplication.vue?vue&type=template&id=7fd74f4c&scoped=true"
import script from "./SnehaSparshamApplication.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamApplication.vue?vue&type=script&lang=js"

import "./SnehaSparshamApplication.vue?vue&type=style&index=0&id=7fd74f4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd74f4c"]])

export default __exports__